import axiosInstance from './axiosInstance';

export const getActiveOfferPromos = () => axiosInstance.get('/offer-promos');

export const offerImageUrl = (image) =>
  `${(process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/api\/?$/, '')}${image}`;
